var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Inject, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import Icon from 'common/UIToolKit/Icon.vue';
import { Pagination } from 'packages/core/Pagination';
import { Talent } from 'packages/talent/entities/Talent';
import DateField from 'ui/v1/DateField.vue';
import { namespace, State } from 'vuex-class';
import { FeatureConfiguration } from 'packages/features/FeatureConfiguration';
import { Job } from 'packages/v3/jobs/Job';
var jobsModule = namespace('jobs');
var formResponseModule = namespace('formResponse');
var talentCardModule = namespace('talentCard');
var FormListView = /** @class */ (function (_super) {
    __extends(FormListView, _super);
    function FormListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(FormListView.prototype, "isInTalentPool", {
        get: function () {
            return this.$route.name.includes('CandidatePool');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormListView.prototype, "isSingleForm", {
        get: function () {
            return this.formResponses && this.formResponses.length === 1;
        },
        enumerable: false,
        configurable: true
    });
    FormListView.prototype.onFormResponsesChanged = function () {
        var _a;
        if (this.formResponses.length > 0 && this.$route.params.candidateId) {
            if ((this.$route.name.includes('TalentCard.Forms') ||
                this.$route.name.includes('TalentCard.ShowForm')) &&
                !this.formResponses
                    .map(function (f) { return f.id.toString(); })
                    .includes((_a = this.$route.params.form) === null || _a === void 0 ? void 0 : _a.toString()) &&
                this.formResponses.length) {
                this.$router.push({
                    name: this.routeNamePrefix + "TalentCard.ShowForm",
                    params: {
                        candidateId: this.$route.params.candidateId,
                        form: this.formResponses[0].id,
                    },
                });
            }
        }
        this.setLoading(false);
    };
    var _a, _b, _c, _d, _e;
    __decorate([
        State,
        __metadata("design:type", typeof (_a = typeof FeatureConfiguration !== "undefined" && FeatureConfiguration) === "function" ? _a : Object)
    ], FormListView.prototype, "features", void 0);
    __decorate([
        jobsModule.State,
        __metadata("design:type", typeof (_b = typeof Job !== "undefined" && Job) === "function" ? _b : Object)
    ], FormListView.prototype, "job", void 0);
    __decorate([
        talentCardModule.State,
        __metadata("design:type", typeof (_c = typeof Talent !== "undefined" && Talent) === "function" ? _c : Object)
    ], FormListView.prototype, "talent", void 0);
    __decorate([
        formResponseModule.State,
        __metadata("design:type", typeof (_d = typeof Array !== "undefined" && Array) === "function" ? _d : Object)
    ], FormListView.prototype, "formResponses", void 0);
    __decorate([
        formResponseModule.State,
        __metadata("design:type", typeof (_e = typeof Pagination !== "undefined" && Pagination) === "function" ? _e : Object)
    ], FormListView.prototype, "pagination", void 0);
    __decorate([
        formResponseModule.State,
        __metadata("design:type", Boolean)
    ], FormListView.prototype, "loading", void 0);
    __decorate([
        formResponseModule.Action,
        __metadata("design:type", Function)
    ], FormListView.prototype, "getFormResponsesForTalent", void 0);
    __decorate([
        formResponseModule.Mutation,
        __metadata("design:type", Function)
    ], FormListView.prototype, "setLoading", void 0);
    __decorate([
        Inject(),
        __metadata("design:type", String)
    ], FormListView.prototype, "routeNamePrefix", void 0);
    __decorate([
        Watch('formResponses', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], FormListView.prototype, "onFormResponsesChanged", null);
    FormListView = __decorate([
        Component({
            components: {
                DateField: DateField,
                Icon: Icon,
            },
        })
    ], FormListView);
    return FormListView;
}(Vue));
export default FormListView;
